import { render, staticRenderFns } from "./Counter.vue?vue&type=template&id=7752aaab&scoped=true&"
import script from "./Counter.vue?vue&type=script&lang=ts&"
export * from "./Counter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7752aaab",
  null
  
)

export default component.exports